<template>
    <WhiteModal bodyClass="choose-language-modal-body" useTopPortal>
        <div class="interface-language-block" :class="{
        selected: selected == lang
    }" @click="selected = lang" v-for="lang in supported_languages" :key="lang">
            <img :src="`/flags/${lang}.png`">
            <div class="gap-row-1xs texts-block">
                <div class="qrw-label-lg bold lang-center lang-title">
                    {{ language_titles[lang] }}
                </div>
                <BaseDivider :color="selected == lang ? 'v1-grey-8' : 'v1-grey-4'"
                    style="width: 80px; max-width: 80px;" />
                <div class="qrw-paragraph-md-sm lang-center lang-subtitle" v-html="language_subtitles[lang]">
                </div>
            </div>

        </div>

        <template #footer>
            <div class="language-actions">
                <div class="qrw-heading-xs bold v1-grey-7-color w-100">
                    {{ language_names[selected] }}
                </div>

                <BaseButton @click="confirmLanguage" size="lg" variant="primary" color="green-5" iconPosition="right"
                    icon="arrow-right-bold" bold>
                    {{ continue_translations[selected] }}
                </BaseButton>
            </div>
        </template>
    </WhiteModal>
</template>

<script>
import AuthAPI from "@/api/auth"

export default {
    data () {
        return {
            supported_languages: ['en', 'ua'],
            language_names: {
                en: 'English',
                ua: 'Українська',
                ru: 'Русский'
            },
            language_titles: {
                en: 'Welcome to QRWaiter!®',
                ru: 'Добро пожаловать в QRWaiter!®',
                ua: 'Вітаємо в QRWaiter!®'
            },
            language_subtitles: {
                en: 'Please, select<br>the language of the interface',
                ru: 'Пожалуйста, выберите<br>язык интерфейса',
                ua: 'Будь ласка, оберіть<br>мову інтерфейсу'
            },
            continue_translations: {
                en: 'Continue',
                ru: 'Продолжить',
                ua: 'Продовжити'
            },

            selected: 'en'
        }
    },
    methods: {
        confirmLanguage () {
            this.$i18n.locale = this.selected;

            AuthAPI.setDashboardLanguage(this.selected);

            this.$store.commit('setOwnerDashboardLanguage', this.selected);
        }
    },
    mounted () {
        this.selected = this.$i18n.locale == 'uk' ? 'ua' : this.$i18n.locale;
    }
}
</script>

<style scoped>
.interface-language-block {
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    box-sizing: border-box;
    cursor: pointer;
    justify-content: center;
    width: 100%;
    align-items: center;
    row-gap: 16px;
    opacity: 0.52;
}

.lang-title {
    color: var(--v1-grey-10-color);
}

.lang-subtitle {
    color: var(--v1-grey-7-color);
}

.interface-language-block.selected {
    opacity: 1;
    background: var(--v1-grey-10-color);
}

.interface-language-block.selected .lang-title {
    color: var(--white-color);
}

.interface-language-block.selected .lang-subtitle {
    color: var(--v1-grey-6-color);
}

.interface-language-block img {
    width: 52px;
    display: block;
    height: 52px;
    max-width: 52px;
    min-height: 52px;
    max-height: 52px;
}

.lang-center {
    text-align: center;
}

.texts-block {
    align-content: center;
    justify-content: center;
    justify-items: center;
    align-items: center;
}

.language-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}
</style>

<style>
.choose-language-modal-body {
    flex-direction: row !important;
    column-gap: 16px;
    padding: 24px !important;
}
</style>